var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 16,
    viewBox: "0 0 11 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51324 0C3.0189 0 1.40331 1.02197 0.134899 2.84456C-0.0951946 3.17519 -0.0242571 3.6285 0.296712 3.87188L1.64477 4.89403C1.96893 5.13981 2.43015 5.08234 2.68393 4.76441C3.46671 3.78375 4.04737 3.21913 5.27009 3.21913C6.23146 3.21913 7.42059 3.83784 7.42059 4.77009C7.42059 5.47484 6.83881 5.83678 5.88956 6.36897C4.78259 6.98959 3.31771 7.76197 3.31771 9.69413V10C3.31771 10.4142 3.65349 10.75 4.06771 10.75H6.33243C6.74665 10.75 7.08243 10.4142 7.08243 10V9.81959C7.08243 8.48022 10.9971 8.42444 10.9971 4.8C10.9971 2.0705 8.16577 0 5.51324 0ZM5.20009 11.6706C4.00646 11.6706 3.03537 12.6417 3.03537 13.8353C3.03537 15.0289 4.00646 16 5.20009 16C6.39371 16 7.36481 15.0289 7.36481 13.8353C7.36481 12.6417 6.39371 11.6706 5.20009 11.6706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.a8dcfd6ee809164d1e5e7938146f6430.svg";
export { ForwardRef as ReactComponent };